import { useEffect, useState } from "react";

const getWindowWidth = () => {
  const { innerWidth: width } = window;
  return {
    width,
  };
};

const useWindowWidth = () => {
  const [windowWidth, setWindowWidth] = useState(getWindowWidth());

  useEffect(() => {
    let timeoutId;
    const handleResize = () => {
      clearTimeout(timeoutId);

      timeoutId = setTimeout(() => setWindowWidth(getWindowWidth()), 150);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowWidth;
};

export default useWindowWidth;
